module.exports = __webpack_public_path__ + "img/yellow.5ac58d82.svg";